import { FC } from 'react'
import { Box, Grid } from '@mui/material'
import MeetingsPage from 'pages/protected/MeetingsPage'

const Meetings: FC = () => {
  return (
    <Box className="thick-border dashboard-page-section">
        <MeetingsPage />
    </Box>
  )
}
export default Meetings